import { jsxs, jsx } from 'react/jsx-runtime';
import { IconShock } from '@fabric-app/icons/old';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { useContextAccessToken } from '../../../../permission/contexts/AnonShareTokenContext.js';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { useMutationMagicRename } from '../../../../magic/mutations/useMutationMagicRename.js';
import { useMutationResourceTitleRename } from '../../../../resource-detail/mutations/useMutationResourceTitleRename.js';
import { toast } from '../../../../store/alerts.js';

const ContextItemRename = () => {
  const accessToken = useContextAccessToken();
  const { resource } = useResourceDataContextSafe();
  const { mutateAsync: mutateMagicRename, isPending } = useMutationMagicRename();
  const { mutateAsync: mutateResourceTitleRename, isPending: isResourceTitleRenamePending } = useMutationResourceTitleRename();
  const handleRename = async () => {
    if (isPending || isResourceTitleRenamePending) return;
    try {
      const name = await mutateMagicRename(resource.id);
      mutateResourceTitleRename({
        resource,
        newTitle: name
      });
      toast({
        id: "magic-rename-success",
        content: "Item renamed successfully"
      });
    } catch {
    }
  };
  if (accessToken) return null;
  return /* @__PURE__ */ jsxs(ContextMenu.Item, {
    onClick: handleRename,
    children: [
      /* @__PURE__ */ jsx(DropdownItemIconContainer, {
        children: /* @__PURE__ */ jsx(IconShock, {})
      }),
      "Name this for me"
    ]
  });
};

export { ContextItemRename };
//# sourceMappingURL=ContextItemRename.js.map
